import { styled } from '@mui/material/styles';
import MuiSvgIcon from '@mui/material/SvgIcon';
export const SvgIcon = styled(MuiSvgIcon)(({ theme }) => ({
    width: '100%',
    height: '100%',
    marginBottom: theme.spacing(-2),
    paddingLeft: theme.spacing(6),
    paddingRight: theme.spacing(6),
    [theme.breakpoints.down('md')]: {
        marginBottom: theme.spacing(-2),
        paddingLeft: theme.spacing(0),
        paddingRight: theme.spacing(0),
    },
}));
//# sourceMappingURL=styles.js.map